import { DEFAULT_GC_TIME, DEFAULT_STALE_TIME } from '@/client/constants';
import { useClientStore } from '@/client/stores/client';
import { withErrorHandling } from '@/client/utils/errors';
import { useQuery } from '@tanstack/react-query';

const NAV_PINS = '/api/admin/ui/nav-pins';

export const navPinKeys = {
  all: ['nav-pins'] as const,
  list: () => [...navPinKeys.all, 'list'] as const,
};

const unwrapEnvelope = (raw: any): any => {
  if (raw != null && typeof raw === 'object' && 'status' in raw && 'data' in raw) {
    return raw.data;
  }
  return raw;
};

export const normalizePins = (raw: unknown): string[] => {
  if (!Array.isArray(raw)) return [];
  const out: string[] = [];
  const seen = new Set<string>();
  for (const item of raw) {
    if (typeof item !== 'string') continue;
    const title = item.trim();
    if (!title || seen.has(title)) continue;
    seen.add(title);
    out.push(title);
    if (out.length >= 20) break;
  }
  return out;
};

export const useNavPinsQuery = (opts?: { enabled?: boolean }) => {
  const request = useClientStore((s) => s.request);

  const fn = withErrorHandling(async (): Promise<string[]> => {
    const raw = await request<any>(NAV_PINS);
    const payload = unwrapEnvelope(raw);
    return normalizePins(payload?.pins ?? payload);
  }, 'Failed to load nav pins');

  return useQuery({
    queryKey: navPinKeys.list(),
    queryFn: () => fn(),
    staleTime: DEFAULT_STALE_TIME,
    gcTime: DEFAULT_GC_TIME,
    enabled: opts?.enabled !== false,
    retry: 1,
  });
};

export { NAV_PINS, unwrapEnvelope };
